import { useEffect } from 'react';
import { useEnvConfig } from './useEnvConfig';

export const useTenantDocumentTitle = () => {
  const { data: env } = useEnvConfig();

  useEffect(() => {
    if (env?.tenantName) {
      document.title = env.tenantName;
    }
  }, [env?.tenantName]);
};
